<script lang="ts" setup>
const route = useRoute()
const query = route.query
defineProps<{
  current?: string
  title?: string
  menu: MenuItem[]
  keepQuery?: boolean
}>()
</script>

<template>
  <m-container :title="title" class="m-menu">
    <ul class="m-menu__list">
      <li v-for="item in menu.filter((m) => !m.hidden)" :key="item.label">
        <NuxtLink
          v-if="item.link"
          :to="{ path: item.link, query: keepQuery ? query : {} }"
          class="item"
          active-class="active"
          :class="{
            group: item.group,
            danger: item.danger,
            disabled: item.disabled
          }"
        >
          <n-icon v-if="item.icon" class="icon" :class="item.icon" />
          {{ item.label }}
        </NuxtLink>
        <a
          v-if="item.onClick"
          :href="item.link"
          class="item"
          :class="{
            active: current === item.label,
            group: item.group,
            danger: item.danger,
            disabled: item.disabled
          }"
          @click="item.onClick"
        >
          <n-icon v-if="item.icon" class="icon" :class="item.icon" />
          {{ item.label }}
        </a>
        <n-badge :value="item.badge" :max="99" :offset="[-12, 9]" />
      </li>
    </ul>
  </m-container>
</template>

<style lang="scss" scoped>
.m-menu {
  width: 180px;
  height: fit-content;
  background-color: #fff;
  padding: 2px 0;
  &__list {
    padding: 0;
    margin: 0;
    list-style: none;
    li {
      height: 36px;
      line-height: 36px;
      padding: 0 20px;
      font-size: 14px;
      color: #333;
      display: flex;
      margin: 4px;
      border-radius: 6px;
      .item {
        cursor: pointer;
        width: 100%;
        text-decoration: none;
        color: var(--color-gray-700);
        display: flex;
        align-items: center;
      }
      &:hover {
        background-color: var(--color-blue-200);
      }
      .icon {
        margin-right: 10px;
        color: var(--color-gray-400);
      }
    }
  }
  .active {
    font-weight: bold;
    color: var(--color-primary) !important;
    i {
      margin-right: 10px;
      color: var(--color-primary);
    }
  }
  .group {
    border-top: 1px solid var(--color-gray-200);
  }
  .danger {
    i {
      color: var(--color-red-500);
    }
  }
  .disabled {
    pointer-events: none;
    color: var(--color-gray-200) !important;
    cursor: not-allowed;
    i {
      margin-right: 10px;
      color: var(--color-gray-200) !important;
    }
  }
}
</style>
